import './interaction_view.js.coffee'
Customer.Ticket ||= {}

class Customer.Ticket.ContextInteractionView extends Customer.Ticket.InteractionView
  template: JST["backbone/templates/customer/ticket/inbox/facebook/context_interaction"]
  viewType: 'context_interaction'
  events:
    'click #go-to-case': 'onGoToCase'

  initialize: (@options = {}) ->
    @interactionsView = @options.interactionsView
    @ticketView = @options.interactionsView.ticketView
    @interaction = new Customer.Interaction(
      conversation: @ticketView.model
      interactionId: @model.get('interaction_id')
      socialContentId: @model.get('id')
    )
    @template = @findTemplate()

  render: ->
    @$el.html(@template(
      socialContent: @model
      conversation: @ticketView.model
      icons: @iconFilenamesBySubtype()
    ))
    profileLink = @$el.find('.user-profile-links')
    # This event can't be defined on top with the others
    # because the third parameter defaults to false
    profileLink.get(0).addEventListener('click', @showProfile, true) if profileLink.length > 0
    if @$el.find('.interaction').hasClass('with-limited-height')
      @addShowEntireMessageButton()
    @$el.toggleClass('response-from-client', @model.get('is_response_from_client'))
    @interaction.loadAuthorInfo()
    @

  ticketType: ->
    return super() if @model.type() == 'webchat'
    'context_interaction'

  onGoToCase: ->
    caseId = @model.get('active_conversation_id')
    if caseId?
      @$el.find('#got-to-case').hide()
      @$el.find('#loading-case').show()
      Backbone.trigger('interaction:go_to_case', caseId, @toggleGoToCase)
    else
      alert('Error: Could not retrieve case id')

  toggleGoToCase: =>
    @$el.find('#loading-case').hide()
    @$el.find('#got-to-case').show()
